<template>
  <modal id="change-password-modal" :modifiers="['no-horizontal-padding']">
    <form class="change-password-modal" @submit="submit">
      <h2 class="change-password-modal__headline">
        {{ $t("headline") }}
      </h2>
      <div v-if="!hasTempPassword" class="change-password-modal__field form__field">
        <label class="change-password-modal__label">
          {{ $t("oldPassword") }}
        </label>
        <show-password v-model="oldPassword" :allow-shorter-old-passwords="true" name="old_password" />
      </div>
      <div class="change-password-modal__field form__field">
        <label class="change-password-modal__label">
          {{ $t("newPassword") }}
        </label>
        <div>
          {{ session }}
        </div>
        <show-password v-model="newPassword" name="new_password" />
      </div>
      <div class="change-password-modal__footer">
        <a class="change-password-modal__cancel" @click="close">
          {{ $t("cancel") }}
        </a>
        <button class="change-password-modal__submit button">
          {{ $t("save") }}
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import Modal from "@/shared/modal"
import events from "@/bl-events/index"
import ShowPassword from "@/shared/show-password.vue"
/**
 * @emits submit
 */
export default {
  name: "ChangePasswordModal",
  components: {
    Modal,
    ShowPassword
  },
  props: {
    hasTempPassword: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    oldPassword: "",
    newPassword: ""
  }),
  methods: {
    close() {
      events.emit("modal:change-password-modal:close")
    },
    submit(e) {
      e.preventDefault()
      this.close()
      this.$emit("submit", {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      })
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Change password",
        oldPassword: "Old password",
        newPassword: "New password",
        cancel: "Cancel",
        save: "Change"
      },
      de: {
        headline: "Passwort ändern",
        oldPassword: "Aktuelles Passwort",
        newPassword: "Neues Passwort",
        cancel: "Abbrechen",
        save: "Ändern"
      }
    }
  }
}
</script>

<style lang="scss">
.change-password-modal {
  width: 100vw;
  max-width: $x-wide-block-width;
  padding: $spacing-48 $spacing-24 $spacing-24;

  &__headline {
    @include font-style(h3);

    margin-bottom: $spacing-24;
  }

  &__field {
    margin-bottom: $spacing-24;
  }

  &__label {
    @include font-style(h4, $color: $mid-grey);

    display: block;
    margin-bottom: $spacing-8;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  &__submit {
    min-width: spacing(118px);
  }

  &__cancel {
    @include font-style(button, $color: $mid-grey);

    margin-right: $base;

    cursor: pointer;
  }
}
</style>
